import { useEffect, useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import FormHelperText from '@mui/material/FormHelperText';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { Button } from '../shared';
import Dropdown from '../shared/dropdown.component';

import { preBookingDomain } from '../../domain';

const RenewalDuration = Object.freeze({ MONTHLY: 1, DAILY: 2 });
const months = [
    {
        label: 'Soonest Available',
        value: moment().format('YYYY-MM-DD'),
        id: 'soonest_available_select',
    },
];

const WaitingListDetailsForm = (props) => {
    const {
        nextStep,
        selectedRoomType,
        sendWaitingList,
        firstName,
        lastName,
        phoneNumber,
        email,
    } = props;
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment().add(1, 'day'));
    const [isLoading, setIsLoading] = useState(false);
    const [waitingListError, setWaitingListError] = useState(null);
    const router = useRouter();
    const roomTypeId = _.get(router, 'query.roomTypeId');
    const renewalDuration = _.get(selectedRoomType, 'renewalDuration');
    const isMonthly = renewalDuration === RenewalDuration.MONTHLY;

    useEffect(() => {
        const dateStart = moment().add(1, 'month');
        const dateEnd = moment().add(11, 'months');
        while (dateEnd.diff(dateStart, 'months') >= 0) {
            months.push({
                label: dateStart.format('MMMM YYYY'),
                value: dateStart.startOf('month').format('YYYY-MM-DD'),
                id: `${dateStart.format('MMMM_YYYY')}_select`,
            });
            dateStart.add(1, 'months');
        }
    }, [months]);

    const onDateRangeChange = (start, end) => {
        setStartDate(start);

        if (!_.isNull(end)) {
            setEndDate(end);
        }
    };

    const onNextClick = () => {
        preBookingDomain.sendWaitingList(roomTypeId, firstName, lastName, phoneNumber, email, startDate, endDate)
            .then(() => {
                setWaitingListError(null);
                setIsLoading(true);
                nextStep();
            })
            .catch((error) => {
                const requestId = _.get(error, 'response.headers.x-request-id');
                const errorMessage = `${_.get(
                    error,
                    'response.data.message',
                )}\n\nRequest ID: ${requestId}`;
                setWaitingListError(errorMessage);
            })
            .finally(() => setIsLoading(false));
    };

    const onMonthChange = (date) => {
        setStartDate(date);
        setEndDate(moment(date).add(1, 'month').endOf('month').format('YYYY-MM-DD'));
    };

    return (
        <>
          
            <Dropdown
                options={months}
                placeholder="Select Month*"
                selectId="monthly_dropdown"
                onChange={onMonthChange}
            />          

            {/* {!isMonthly && (
                <HorizontalDateRangePicker
                    startDate={startDate}
                    endDate={endDate}
                    onDateRangeChange={onDateRangeChange}
                    dateFormat="DD MMM YYYY"
                    inputWidth={100}
                />
            )} */}

            <FormHelperText error>{waitingListError}</FormHelperText>
            <Button
                id="waiting-list-dates-next-button"
                className="waiting-list-details-form-button"
                variant="contained"
                color="primary"
                isLoading={isLoading}
                onClick={onNextClick}
            >
                Next
            </Button>
        </>
    );
};

export default WaitingListDetailsForm;

WaitingListDetailsForm.propTypes = {
    nextStep: PropTypes.string,
    selectedRoomType: PropTypes.object,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,

    sendWaitingList: PropTypes.func,
};

